import React, { useCallback, useEffect, useState, useRef } from 'react';
import {
  LoadScript,
  GoogleMap,
  Marker,
  Circle,
  Polygon,
} from '@react-google-maps/api';
import { FormHandles } from '@unform/core';

import api from '../../services/api';
import { useAuth } from '../../hooks/auth';
import { useToast } from '../../hooks/toast';
import { formatPrice } from '../../utils/format';
import Loading from '../../components/Loading';
import Sidebar from '../../components/Sidebar';
import Input from '../../components/Inputs/Input';

import { Container, Content, FormView, MapView } from './styles';

const options = {
  strokeColor: '#333',
  strokeOpacity: 0.8,
  strokeWeight: 1,
  fillColor: '#333',
  fillOpacity: 0.05,
  clickable: false,
  draggable: false,
  editable: false,
  visible: true,
  radius: 500,
  zIndex: 1,
  scale: 1000,
};
const circless = [
  { radius: 1000, options },
  { radius: 2000, options },
  { radius: 3000, options },
  { radius: 4000, options },
  { radius: 5000, options },
  { radius: 8000, options },
  { radius: 12000, options },
  { radius: 16000, options },
];
const paths = [
  { lat: -20.60008770958747, lng: -47.37190402443836 },
  { lat: -20.598156199414856, lng: -47.37408274442967 },
  { lat: -20.596117231005355, lng: -47.37500027130245 },
  { lat: -20.586137627946005, lng: -47.386121733632386 },
  { lat: -20.586137627946005, lng: -47.386121733632386 },
  { lat: -20.5808794381602, lng: -47.39563661348083 },
  { lat: -20.57524284930806, lng: -47.39983681084158 },
  { lat: -20.57551306888727, lng: -47.40909834719963 },
  { lat: -20.571177034714548, lng: -47.41430736451207 },
  { lat: -20.566570310595537, lng: -47.41662199112824 },
  { lat: -20.563048354746947, lng: -47.412569803139206 },
  { lat: -20.559525052355994, lng: -47.41748911083912 },
  { lat: -20.557086384428132, lng: -47.41719933871482 },
  { lat: -20.551665711993316, lng: -47.423854408967244 },
  { lat: -20.55491719560606, lng: -47.424723205655695 },
  { lat: -20.557084047214428, lng: -47.42877521426977 },
  { lat: -20.557082479946406, lng: -47.434852653716256 },
  { lat: -20.559790852494526, lng: -47.439483914980386 },
  { lat: -20.559790314896606, lng: -47.44122039017922 },
  { lat: -20.553282681305294, lng: -47.453084182473454 },
  { lat: -20.550027197336068, lng: -47.46176537762005 },
  { lat: -20.55056684199086, lng: -47.46668573850862 },
  { lat: -20.554641294672543, lng: -47.47460791170532 },
  { lat: -20.55446485042642, lng: -47.478347913260976 },
  { lat: -20.55218753225905, lng: -47.481339244783804 },
  { lat: -20.546585268155557, lng: -47.47965443390407 },
  { lat: -20.54150940616517, lng: -47.4747911289871 },
  { lat: -20.538533391533367, lng: -47.473107451181356 },
  { lat: -20.537133738706807, lng: -47.46992840224195 },
  { lat: -20.53765965841069, lng: -47.468058732447275 },
  { lat: -20.53573413798013, lng: -47.46637549001948 },
  { lat: -20.534047414300417, lng: -47.467074595677005 },
  { lat: -20.534047414300417, lng: -47.467074595677005 },
  { lat: -20.530218698374004, lng: -47.46181158428862 },
  { lat: -20.52516727869863, lng: -47.45590227519252 },
  { lat: -20.525167323705993, lng: -47.45551693818305 },
  { lat: -20.523844426761517, lng: -47.452691020031224 },
  { lat: -20.51013120009182, lng: -47.450891750136016 },
  { lat: -20.50339500522047, lng: -47.44511198362966 },
  { lat: -20.50182750866887, lng: -47.43625014328781 },
  { lat: -20.4978575308605, lng: -47.430597982453406 },
  { lat: -20.495451262443883, lng: -47.429827150154566 },
  { lat: -20.486908424554432, lng: -47.43445052661276 },
  { lat: -20.480531489393215, lng: -47.43470689838991 },
  { lat: -20.477764308227865, lng: -47.432523302468695 },
  { lat: -20.477643986856727, lng: -47.432523294770164 },
  { lat: -20.47547859771728, lng: -47.42597312396097 },
  { lat: -20.46885688758152, lng: -47.41710897239071 },
  { lat: -20.467173016356977, lng: -47.41055816588522 },
  { lat: -20.467173016356977, lng: -47.41055816588522 },
  { lat: -20.47427300557737, lng: -47.406705433260726 },
  { lat: -20.471987057674987, lng: -47.40002616896552 },
  { lat: -20.468377171804995, lng: -47.3937324498194 },
  { lat: -20.475115596209385, lng: -47.3866678827029 },
  { lat: -20.48413903965924, lng: -47.38590753856192 },
  { lat: -20.49502639423166, lng: -47.390174189255596 },
  { lat: -20.507244762726707, lng: -47.38210593725855 },
  { lat: -20.50524348014083, lng: -47.37475282243908 },
  { lat: -20.500798979510655, lng: -47.37143341264177 },
  { lat: -20.517945175246176, lng: -47.34498498821621 },
  { lat: -20.52021133803335, lng: -47.346258203716225 },
  { lat: -20.521807856640667, lng: -47.34902599754204 },
  { lat: -20.532976759500333, lng: -47.35264203971028 },
  { lat: -20.554513206296598, lng: -47.350503437905765 },
  { lat: -20.556707532510025, lng: -47.35263248491816 },
  { lat: -20.55730640393512, lng: -47.35454922543259 },
  { lat: -20.55929978667517, lng: -47.35199237150221 },
  { lat: -20.560096625101135, lng: -47.349435950552795 },
  { lat: -20.56305800877325, lng: -47.34706047651877 },
  { lat: -20.567626522927466, lng: -47.34750262985447 },
  { lat: -20.569703790033447, lng: -47.349941817578866 },
  { lat: -20.571989379268505, lng: -47.35504262899846 },
  { lat: -20.571990543940483, lng: -47.3597004612855 },
  { lat: -20.571160257542875, lng: -47.361031457808366 },
  { lat: -20.573237281077684, lng: -47.36347076271283 },
  { lat: -20.57302958555211, lng: -47.36324901019785 },
  { lat: -20.578843148614546, lng: -47.36058597505303 },
  { lat: -20.589018095021697, lng: -47.36147067519832 },
  { lat: -20.595663338889548, lng: -47.363909124121115 },
  { lat: -20.597740277394053, lng: -47.36634879687792 },
  { lat: -20.60008770958747, lng: -47.37190402443836 },
];

interface AreaDATA {
  id: string;
  taxa_1km: number;
  taxa_2km: number;
  taxa_3km: number;
  taxa_4km: number;
  taxa_5km: number;
  taxa_8km: number;
  taxa_12km: number;
  taxa_16km: number;
  tempo_1k: number;
  tempo_2k: number;
  tempo_3k: number;
  tempo_4k: number;
  tempo_5k: number;
  tempo_8k: number;
  tempo_12k: number;
  tempo_16k: number;
}

const AreaEntrega: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { company, permissions } = useAuth();
  const { addToast } = useToast();
  const [loading, setLoading] = useState(true);

  const [map, setMap] = useState<google.maps.Map | null>(null);
  const [loadingMap, setLoadingMap] = useState(false);

  const [areas, setAreas] = useState<AreaDATA>({} as AreaDATA);
  const [circles, setCircles] = useState<any>(circless);
  const [btnDisable, setBtnDisable] = useState(true);

  const handleMoeda = useCallback((id_field: string) => {
    let moedastr = formRef.current?.getFieldValue(`${id_field}`);
    moedastr = moedastr.replace(/\D/g, '');

    if (moedastr) {
      const moeda = parseInt(moedastr.replace(/[\D]+/g, ''));

      let tmp = `${moeda}`;
      tmp = tmp.replace(/([0-9]{2})$/g, ',$1');
      if (tmp.length > 6)
        tmp = tmp.replace(/([0-9]{3}),([0-9]{2}$)/g, '.$1,$2');

      formRef.current?.setFieldValue(`${id_field}`, `R$ ${tmp}`);
    } else {
      moedastr = moedastr.replace(/\D/g, '');
      formRef.current?.setFieldValue(`${id_field}`, `${moedastr}`);
    }
  }, []);

  useEffect(() => {
    formRef.current?.reset();

    api.post('portal/areaentrega/index', {
        data: { id: '' },
      })
      .then(response => {
        setAreas(response.data);
        formRef.current?.setData(response.data);
      })
      .finally(() => {
        setLoading(false);
        setLoadingMap(true);
        map?.panTo(company.endereco.location);

        setTimeout(() => {
          formRef.current?.setFieldValue(
            'taxa_1km',
            formatPrice(formRef.current?.getFieldValue('taxa_1km')),
          );
          formRef.current?.setFieldValue(
            'taxa_2km',
            formatPrice(formRef.current?.getFieldValue('taxa_2km')),
          );
          formRef.current?.setFieldValue(
            'taxa_3km',
            formatPrice(formRef.current?.getFieldValue('taxa_3km')),
          );
          formRef.current?.setFieldValue(
            'taxa_4km',
            formatPrice(formRef.current?.getFieldValue('taxa_4km')),
          );
          formRef.current?.setFieldValue(
            'taxa_5km',
            formatPrice(formRef.current?.getFieldValue('taxa_5km')),
          );
          formRef.current?.setFieldValue(
            'taxa_8km',
            formatPrice(formRef.current?.getFieldValue('taxa_8km')),
          );
          formRef.current?.setFieldValue(
            'taxa_12km',
            formatPrice(formRef.current?.getFieldValue('taxa_12km')),
          );
          formRef.current?.setFieldValue(
            'taxa_16km',
            formatPrice(formRef.current?.getFieldValue('taxa_16km')),
          );
        }, 300);
      });
  }, [handleMoeda, company, map]);

  const onMapLoad = useCallback((mapa: google.maps.Map) => {
    setMap(mapa);
  }, []);
  const onMapUnmount = useCallback(() => {
    setMap(null);
  }, []);
  const handleMouseOver = useCallback(
    (km: any, index: any) => {
      // const index = circless.findIndex(item => item.radius === km);
      const aux = circless[index];
      setCircles(circles.filter((item: any) => item.radius !== km));

      aux.options.fillOpacity = 0.04;
      aux.options.strokeColor = '#FF0000';

      setCircles(() => [...circles, aux]);
    },
    [circles],
  );
  const handleMouseOut = useCallback((km: any, index: any) => {
    // const index = circless.findIndex(item => item.radius === km);
    const aux = circless[index];

    setCircles(circless.filter(item => item.radius !== km));

    aux.options.fillOpacity = 0.01;
    aux.options.strokeColor = '#333';

    setCircles((items: any) => [...items, aux]);
  }, []);

  const handleSubmit = useCallback(
    async (data: any) => {
      data.taxa_1km = parseFloat(
        data.taxa_1km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.taxa_2km = parseFloat(
        data.taxa_2km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.taxa_3km = parseFloat(
        data.taxa_3km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.taxa_4km = parseFloat(
        data.taxa_4km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.taxa_5km = parseFloat(
        data.taxa_5km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.taxa_8km = parseFloat(
        data.taxa_8km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.taxa_12km = parseFloat(
        data.taxa_12km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.taxa_16km = parseFloat(
        data.taxa_16km.replace('R$', '').replace(' ', '').replace(',', '.'),
      );
      data.tempo_1km = parseFloat(data.tempo_1km);
      data.tempo_2km = parseFloat(data.tempo_2km);
      data.tempo_3km = parseFloat(data.tempo_3km);
      data.tempo_4km = parseFloat(data.tempo_4km);
      data.tempo_5km = parseFloat(data.tempo_5km);
      data.tempo_8km = parseFloat(data.tempo_8km);
      data.tempo_12km = parseFloat(data.tempo_12km);
      data.tempo_16km = parseFloat(data.tempo_16km);
      data.id = areas.id ? areas.id : 0;

      await api
        .post('portal/areaentrega/index', {
          data,
        })
        .then(() => {
          setBtnDisable(true);

          addToast({
            type: 'success',
            title: 'Áreas de Entregas',
            description: 'Suas Áreas de Entregas cadastradas com sucesso.',
          });
        });
    },
    [areas, addToast],
  );

  return (
    <Container>
			<Sidebar />

      {loading ? (
        <Loading />
      ) : (
				<Content>
					{permissions.alterar && (
						<FormView ref={formRef} initialData={areas} onSubmit={handleSubmit}>
							<table>
								<thead>
									<tr>
										<th>Alcance</th>
										<th>Taxa*</th>
										<th>Tempo(min.)</th>
									</tr>
								</thead>
								
								<tbody>
									{/* 1km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(1000, 0)}
										onMouseLeave={() => handleMouseOut(1000, 0)}
									>
										<td>Até 1km</td>
										<td>
											<Input
												name="taxa_1km"
												type="text"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_1km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_1km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>

									{/* 2km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(2000, 1)}
										onMouseLeave={() => handleMouseOut(2000, 1)}
									>
										<td>Até 2km</td>
										<td>
											<Input
												name="taxa_2km"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_2km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_2km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>

									{/* 3km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(3000, 2)}
										onMouseLeave={() => handleMouseOut(3000, 2)}
									>
										<td>Até 3km</td>
										<td>
											<Input
												name="taxa_3km"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_3km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_3km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>

									{/* 4km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(4000, 3)}
										onMouseLeave={() => handleMouseOut(4000, 3)}
									>
										<td>Até 4km</td>
										<td>
											<Input
												name="taxa_4km"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_4km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_4km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>

									{/* 5km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(5000, 4)}
										onMouseLeave={() => handleMouseOut(5000, 4)}
									>
										<td>Até 5km</td>
										<td>
											<Input
												name="taxa_5km"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_5km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_5km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>

									{/* 8km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(8000, 5)}
										onMouseLeave={() => handleMouseOut(8000, 5)}
									>
										<td>Até 8km</td>
										<td>
											<Input
												name="taxa_8km"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_8km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_8km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>

									{/* 12km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(12000, 6)}
										onMouseLeave={() => handleMouseOut(12000, 6)}
									>
										<td>Até 12km</td>
										<td>
											<Input
												name="taxa_12km"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_12km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_12km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>

									{/* 16km */}
									<tr
										className="tr"
										onMouseOver={() => handleMouseOver(16000, 7)}
										onMouseLeave={() => handleMouseOut(16000, 7)}
									>
										<td>Até 16km</td>
										<td>
											<Input
												name="taxa_16km"
												placeholder="R$ 0,00"
												onChange={() => {
													handleMoeda('taxa_16km');
													setBtnDisable(false);
												}}
											/>
										</td>
										<td>
											<Input
												type="number"
												name="tempo_16km"
												placeholder="00"
												onChange={() => setBtnDisable(false)}
											/>
										</td>
									</tr>
								</tbody>
							</table>

							<div>
								<button type="submit" disabled={btnDisable}>
									Salvar
								</button>
							</div>
						</FormView>
					)}

					<MapView>
						{loadingMap && (
								<LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''}>
								<GoogleMap
									onLoad={onMapLoad}
									onUnmount={onMapUnmount}
									mapContainerStyle={{
										width: '100%',
										height: '100vh',
										borderRadius: '8px',
									}}
									center={company.endereco.location}
									zoom={13}
									clickableIcons={true}
								>
									<Marker position={company.endereco.location} />

									{circles.map((circle: any, indice: any) => (
										<Circle
											key={indice}
											center={company.endereco.location}
											options={circle.options}
											radius={circle.radius}
										/>
									))}

									<Polygon
										options={{
											fillColor: '#039BE5',
											fillOpacity: 0.1,
											strokeColor: '#039BE5',
											strokeOpacity: 1,
											strokeWeight: 2,
											clickable: false,
											draggable: false,
											editable: false,
											geodesic: false,
											zIndex: 1,
										}}
										path={paths}
									/>
								</GoogleMap>
							</LoadScript>
						)}
					</MapView>
				</Content>
      )}
    </Container>
  );
};

export default AreaEntrega;
